<template>
  <div class="py-4 container-fluid">
    <div class=" row">
      <div class="col-12">
        <div class="card">
          <div class="card-header pb-0">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <h6 class="mb-0">Lista de Producción</h6>
              <div class="d-flex gap-2">
                <button class="btn btn-info btn-sm" @click="openFiltersModal">
                  <i class="fa fa-filter me-1"></i> Filtros
                </button>
                <router-link
                  :to="{ name: 'Production Create' }"
                  class="btn btn-primary btn-sm"
                  data-toggle="tooltip"
                  data-original-title="Agregar producción"
                >
                  Agregar <i class="fa fa-plus ms-1"></i>
                </router-link>
              </div>
            </div>
            <!-- se agg una row mas para la busqueda-->
            <div class="row">
              <!-- Columna de búsqueda -->
              <div class="col-md-6 mb-3">
                <label for="searchQuery" class="mb-1">Buscar</label>
                <input
                  type="text"
                  v-model="searchQuery"
                  id="searchQuery"
                  class="form-control"
                  placeholder="Buscar producción..."
                  @input="onSearchInput"
                />
              </div>
              <!-- Columna de fechas -->
              <div class="col-md-3 mb-3">
                <label for="startDate" class="mb-1">Desde</label>
                <input
                  type="date"
                  v-model="startDate"
                  id="startDate"
                  class="form-control"
                  @change="fetchData(null)"
                />
              </div>
              <div class="col-md-3 mb-3">
                <label for="endDate" class="mb-1">Hasta</label>
                <input
                  type="date"
                  v-model="endDate"
                  id="endDate"
                  class="form-control"
                  @change="fetchData(null)"
                />
              </div>
            </div>
          </div>
          <div class="card-body px-0 pt-0 pb-2">
            <div class="table-responsive p-0">

              <table class="table align-items-center mb-0">
                <thead>
                  <tr>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">#</th>
                    <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Producción</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">N° de
                      compra</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Cantidad
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Total
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Estado
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Etapa
                    </th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de
                      corte</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Fecha de
                      asignación</th>
                    <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                      Opciones
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="value in data" :key="value.id">
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <h6 class="mb-0 text-sm">{{ value.id }}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex px-2 py-1">
                        <div class="d-flex flex-column justify-content-center">
                          <router-link
                            :to="{ name: 'Production Create', query: { id: value.id } }"
                            class="text-secondary font-weight-bold text-xs"
                            data-toggle="tooltip"
                            data-original-title="Editar Registro"
                          >
                            <h6 class="mb-0 text-sm">{{ value?.name }} ({{ value?.model?.ref }})</h6>
                          </router-link>
                          <p class="text-xs text-secondary mb-0">{{ value.description }}</p>
                        </div>
                      </div>
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value?.purchase_number || '-' }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ value?.total_quantity }}
                    </td>
                    <td class="align-middle text-center text-sm">
                      {{ parseFloat(value?.total_global).toLocaleString('es-ES', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) }}
                    </td>
                    
                    <td class="align-middle text-center text-sm">
                      <span class="badge badge-sm" :class="getStatusClass(value.status)">
                        {{ getStatusText(value.status) }}
                      </span>
                    </td>

                    <td class="align-middle text-center text-sm">
                      <select
                        :value="value.etapa || ''"
                        class="form-select form-select-sm etapa-select"
                        @change="updateEtapa(value.id, $event.target.value)"
                      >
                        <option value="">-</option>
                        <option v-for="etapa in etapaOptionsFor(value)" :key="etapa" :value="etapa">{{ etapa }}</option>
                      </select>
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">

                        {{ formatDate(value.delivery_date??'') }}                      
                      </span>
                    </td>

                    <td class="align-middle text-center">
                      <span class="text-secondary text-xs font-weight-bold">

                        {{ new Date(value.created_at).toLocaleDateString('es-ES') }}                      
                      </span>
                    </td>
                    <td class="align-middle text-center">
                      <router-link
                        :to="{ name: 'Production Create', query: { id: value.id } }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Editar Registro">
                        <i :class="value.status > 1 ? 'fa fa-eye' : 'fa fa-pencil-alt'"></i>
                      </router-link>

                      <a v-if="value.status == 0" @click="deleteUser(value.id)"
                        class="text-secondary font-weight-bold text-xs cursor-pointer" style="margin-left: 15px;"
                        data-toggle="tooltip" data-original-title="Eliminar registro">
                        <i class="fa fa-trash"></i>
                      </a>
                    </td>
                  </tr>

                  <tr v-if="data.length === 0">
                    <td colspan="10" class="text-center text-xxs">No hay registros disponibles</td>
                  </tr>

                </tbody>
              </table>

              <!-- Paginación -->
              <div class="pagination p-3">
                <a v-for="link in links" :key="link.label" class="page-item cursor-pointer" @click="fetchData(link.url)"
                  :disabled="!link.url || link.active" :class="{ 'active': link.label === currentPage.toString() }">
                  {{ link.label }}
                </a>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>

  <!-- Modal Filtros -->
  <div class="modal fade" id="ModalFilters" tabindex="-1" aria-labelledby="filtersModalLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content card">
        <div class="modal-header">
          <h5 class="modal-title" id="filtersModalLabel">Filtros</h5>
          <button type="button" class="btn-close" @click="closeFiltersModal"></button>
        </div>
        <div class="modal-body">
          <div class="mb-3">
            <label for="etapaFilterSelect" class="mb-1">Filtrar por etapa</label>
            <select v-model="etapaFilter" class="form-select" id="etapaFilterSelect">
              <option value="">Seleccionar</option>
              <option v-for="oficio in oficios" :key="oficio.id" :value="oficio.name">{{ oficio.name }}</option>
            </select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="clearFilters">Limpiar</button>
          <button type="button" class="btn btn-primary" @click="applyFilters">Aplicar</button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>


<script>
import { mapGetters } from 'vuex';
import Swal from 'sweetalert2';
import { Modal } from 'bootstrap';
export default {
  name: 'ProjectsTable',
  data() {
    return {
      searchQuery: this.$store.getters['production/searchQuery'] || '',
      searchTimeout: null,
      startDate: this.$store.getters['production/startDate'] || '',
      endDate: this.$store.getters['production/endDate'] || '',
      etapaFilter: this.$store.getters['production/etapaFilter'] || '',
      filterModal: null,
      oficios: [],
    };
  },
  computed: {
    ...mapGetters('production', ['allData', 'currentPage', 'lastPage', 'pagination', 'links']), // Mapea el getter allUsers
    currentPage() {
      return this.$store.state.production.currentPage; // Obtiene la página actual
    },
    lastPage() {
      return this.$store.state.production.lastPage; // Obtiene la última página
    },
    data() {
      return this.allData; // Retorna los usuarios desde el store
    },
    links() {
      return this.$store.getters['production/links']; // Retorna los links
    },
  },
  methods: {
    formatDate(dateString) {
      if(dateString==''){return ''}
      const parts = dateString.split('-'); // Divide la fecha en partes
      return `${parts[2]}/${parts[1]}/${parts[0]}`; // Reorganiza a dd/mm/yyyy
    },
    getStatusClass(status) {
      // Convertir status a número si es string, null o undefined
      if (status === null || status === undefined || status === '') {
        return 'bg-gradient-secondary';
      }
      const statusNum = parseInt(status);
      
      if (isNaN(statusNum)) {
        return 'bg-gradient-secondary';
      }
      
      if (statusNum === 0) {
        return 'bg-gradient-warning'; // Pendiente
      } else if (statusNum === 1) {
        return 'bg-gradient-primary'; // Producción
      } else if (statusNum === 2) {
        return 'bg-gradient-success'; // Terminado
      } else if (statusNum === 3) {
        return 'bg-gradient-danger'; // Cancelado
      } else {
        return 'bg-gradient-secondary'; // Desconocido
      }
    },
    getStatusText(status) {
      // Convertir status a número si es string, null o undefined
      if (status === null || status === undefined || status === '') {
        return 'Sin estado';
      }
      const statusNum = parseInt(status);
      
      if (isNaN(statusNum)) {
        return 'Sin estado';
      }
      
      if (statusNum === 0) {
        return 'Pendiente';
      } else if (statusNum === 1) {
        return 'Producción';
      } else if (statusNum === 2) {
        return 'Terminado';
      } else if (statusNum === 3) {
        return 'Cancelado';
      } else {
        return 'Desconocido';
      }
    },
    onSearchInput() {
      this.$store.commit('production/SET_SEARCH_QUERY', this.searchQuery);
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchData(null);
      }, 400);
    },
    async fetchData(pageUrl = null) {

      this.$store.commit('production/SET_SEARCH_QUERY', this.searchQuery);
      this.$store.commit('production/SET_START_DATE', this.startDate);
      this.$store.commit('production/SET_END_DATE', this.endDate);

      const params = {
        search: this.searchQuery,
        start_date: this.startDate,
        end_date: this.endDate,
        etapa: this.etapaFilter || '',
        page: pageUrl ? new window.URL(pageUrl).searchParams.get("page") || 1 : 1
      };

      await this.$store.dispatch('production/fetchData', params);
    },
    async deleteUser(userId) {
      try {
        const result = await Swal.fire({
          title: '¿Estás seguro?',
          text: 'Esta acción no se puede deshacer.',
          icon: 'warning',
          showCancelButton: false,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Sí, eliminar!',
          cancelButtonText: 'Cancelar'
        });

        if (result.isConfirmed) {
          const response = await this.$store.dispatch("production/delete", userId);
          if (response && response.status >= 200 && response.status < 300) {

            this.fetchData(null);

            await Swal.fire(
              'Eliminado!',
              'El registro se ha sido eliminado correctamente.',
              'success'
            );
          } else {
            throw new Error(response.data.message || 'Error al eliminar el usuario');
          }
        }
      } catch (error) {
        console.error("Error al eliminar el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al eliminar el registro',
        });
      }
    },
    openFiltersModal() {
      const modalElement = document.getElementById('ModalFilters');
      this.filterModal = new Modal(modalElement);
      this.filterModal.show();
    },
    closeFiltersModal() {
      if (this.filterModal) {
        this.filterModal.hide();
      }
    },
    applyFilters() {
      this.$store.commit('production/SET_ETAPA_FILTER', this.etapaFilter);
      this.fetchData(null);
      this.closeFiltersModal();
    },
    clearFilters() {
      this.etapaFilter = '';
      this.$store.commit('production/SET_ETAPA_FILTER', '');
      this.fetchData(null);
      this.closeFiltersModal();
    },
    // Opciones de etapa: los oficios por los que pasa la producción; se conserva la etapa guardada si no es uno de ellos
    etapaOptionsFor(production) {
      const names = (production.oficios_progress || []).map(step => step.name);
      if (production.etapa && !names.includes(production.etapa)) names.push(production.etapa);
      return names;
    },
    async updateEtapa(id, etapa) {
      try {
        await this.$store.dispatch('production/updateEtapa', { id, etapa });
      } catch (error) {
        console.error('Error al actualizar etapa:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'No se pudo actualizar la etapa.',
        });
      }
    },
    async getOficios() {
      try {
        this.oficios = await this.$store.dispatch('users/getOficios');
      } catch (error) {
        console.error('Error al cargar oficios:', error);
        this.oficios = [];
      }
    }

  },
  mounted() {
    this.getOficios();
    this.fetchData(null);
  },
};
</script>

<style scoped>
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.page-item {
  margin: 0 5px;
}

.active {
  font-weight: bold;
  /* Estilo para la página activa */
}

.etapa-select {
  min-width: 140px;
  font-size: 0.75rem;
  padding: 0.25rem 0.5rem;
}
</style>